<div
  class="content"
  #content
  (pointerdown)="startCanvasDragAndDrop($event)"
  (pointerup)="disableMoveByDragAndDrop()"
  [class.isBackgroundEditing]="isShiftDown$ | async"
  [class.isBackgroundDragging]="isBackgroundDragging"
  [style.--canvaScale]="scale | async"
  [ngStyle]="{
    transform:
      'translate(' +
      (currentX$ | async) +
      'px,' +
      (currentY$ | async) +
      'px) scale(' +
      (scale | async) +
      ')',
    'width.px': width$ | async,
    'height.px': height$ | async,
  }"
>
  @if (
    (currentPage$ | async) === 0 &&
    (currentTemplate$ | async)?.type === 'TwoPage'
  ) {
    <div class="description">
      <div style="font-size: calc(18px / {{ scale | async }}) ">Tył</div>
      <div style="font-size: calc(18px / {{ scale | async }}) ">Okładka</div>
    </div>
  }
  @if (imageUrl$ | async; as backgroundUrl) {
    <div class="bgFrame">
      <img
        draggable="false"
        [src]="backgroundUrl"
        [style.transform]="backgroundTransformStyle$ | async"
        (load)="backgroundLoaded()"
        #backgroundImage
        class="bg"
      />
    </div>
  }
  @for (
    item of visibleStructure$ | async;
    track trackGroup(itemIndex, item);
    let itemIndex = $index;
    let itemsCount = $count
  ) {
    @switch (item.type) {
      @case ('logo') {
        <div
          (dblclick)="openEditMode.emit(item)"
          class="element"
          [ngClass]="{
            locked: item.config.locked,
          }"
        >
          @if (
            !item.editMode &&
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              (drag)="onDrag($event, item)"
              (dragStart)="onDragStart($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (resizeEnd)="onResizeEnd($event, item)"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              [rotatable]="true"
              [draggable]="!item.editMode"
              [resizable]="!item.editMode"
              [scalable]="!item.editMode"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              [target]="logo"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="content | tabloOtherElementsForSnap: logo"
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [bounds]="content | tabloBoundArea: (scale | async)"
              [snapDistFormat]="snapDistFormat"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }
          <div
            #logo
            class="logoContainer"
            [id]="item.id"
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              transform: item.config.transform,
              'z-index': item.config.index,
              opacity: item.config.hidden
                ? 0
                : item.config.config?.opacity
                  ? item.config.config.opacity
                  : 1,
            }"
          >
            <div
              class="focusStealer"
              [attr.data-id]="item.id"
              [attr.data-id]="item.id"
            ></div>
            @if (!isTemplate && item.config.fileName) {
              <img
                draggable="false"
                [src]="item.config.fileName | publicImageUrl: 500 : 500 | async"
              />
            } @else {
              <ng-template [ngTemplateOutlet]="logoPlaceholder"></ng-template>
            }
            <ng-template #logoPlaceholder>
              @if (isTemplate) {
                <img
                  draggable="false"
                  src="/assets/designer/schoolLogoPlaceholder.svg"
                />
              } @else {
                <ng-template
                  [ngTemplateOutlet]="missingLogoInRealTablo"
                ></ng-template>
              }

              <ng-template #missingLogoInRealTablo>
                <lib-tablo-fix-school-logo
                  [publicSessionOrganizationId]="publicSessionOrganizationId"
                ></lib-tablo-fix-school-logo>
              </ng-template>
            </ng-template>
          </div>
        </div>
      }
      @case ('photographerLogo') {
        <div
          (dblclick)="openEditMode.emit(item)"
          class="element"
          [ngClass]="{
            locked: item.config.locked,
          }"
          [ngStyle]="{
            'width.px': item.config.width + 60,
            'height.px': item.config.height + 60,
            'left.px': item.config.x - 30,
            'top.px': item.config.y - 30,
          }"
        >
          @if (
            !item.editMode &&
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              (drag)="onDrag($event, item)"
              (dragStart)="onDragStart($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (resizeEnd)="onResizeEnd($event, item)"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              [rotatable]="true"
              [draggable]="!item.editMode"
              [resizable]="!item.editMode"
              [scalable]="!item.editMode"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              [target]="logo"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="content | tabloOtherElementsForSnap: logo"
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [bounds]="content | tabloBoundArea: (scale | async)"
              [snapDistFormat]="snapDistFormat"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }
          <div
            #logo
            class="logoContainer"
            [id]="item.id"
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              transform: item.config.transform,
              'z-index': item.config.index,
              opacity: item.config.hidden
                ? 0
                : item.config.config?.opacity
                  ? $safeNavigationMigration(item.config.config?.opacity)
                  : 1,
            }"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>

            <img
              draggable="false"
              [src]="photographerLogo | publicImageUrl: 500 : 500 | async"
            />
          </div>
        </div>
      }

      @case ('group') {
        <div
          (dblclick)="openEditMode.emit(item)"
          [ngClass]="{
            locked: item.config.locked,
          }"
          class="element"
        >
          @if (
            !item.editMode &&
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              (drag)="onDrag($event, item)"
              (dragStart)="onDragStart($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (resizeEnd)="onResizeEnd($event, item)"
              [draggable]="!item.editMode"
              [resizable]="!item.editMode"
              [scalable]="!item.editMode"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              [rotatable]="item.config.config.isNameOnly"
              [target]="children"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="
                content | tabloOtherElementsForSnap: children
              "
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [snapDistFormat]="snapDistFormat"
              [bounds]="content | tabloBoundArea: (scale | async)"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }
          <div
            class="elementContainer"
            [id]="item.id"
            #children
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              transform: item.config.transform,
              'z-index': item.config.index,
              opacity: item.config.hidden ? 0 : 1,
            }"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>
            @if (!item.editMode && item.id === (hoverOver | async)) {
              <div
                class="hoverMenu"
                style="
          position: absolute;
          top: calc(-50px / {{ scale | async }});
          right: 20px;
          transform-origin: top right;

          transform: scale(calc(1 / {{ scale | async }}));
          z-index: 50;
        "
              >
                <button mat-raised-button (click)="openEditMode.emit(item)">
                  Edytuj grupę
                </button>
                @if (
                  !isTemplate &&
                  !item.isLeadingChild &&
                  item.config.list.type !== 'teacher'
                ) {
                  <button mat-raised-button (click)="assignPhotos(item)">
                    Przypisz zdjęcia
                  </button>
                }
              </div>
            }

            @if (item.editMode) {
              <div
                class="closeEdit"
                (click)="closeEditMode.emit()"
                style="
          position: absolute;
          top: calc(-50px / {{ scale | async }});
          right:20px;
          transform-origin: top right;

          transform: scale(calc(1 / {{ scale | async }}));
          z-index: 50;
"
              >
                <button mat-raised-button>Zakończ edycję</button>
              </div>
            }
            <lib-tablo-members-group
              [leadingChildId]="leadingChildId"
              [isLeadingChild]="item.isLeadingChild"
              [sourceImages]="sourceGroups$ | async"
              [contextId]="contextId"
              [groupElementId]="item.id"
              [context]="item.config.list.type"
              [isTemplate]="isTemplate"
              [publicSessionOrganizationId]="publicSessionOrganizationId"
              [publicSessionOrganizationGroupId]="
                publicSessionOrganizationGroupId
              "
              [imagesContext]="context"
              [config]="item.config"
              [images]="sourceGroups$ | async"
              [editable]="item.editMode"
              [disabled]="disabled"
              [projectId]="projectId"
              (placeholdersUpdated)="placeholdersUpdated($event, item)"
              (handPickUpdated)="handPickUpdated($event, item)"
              (allImagesLoaded)="groupMembersLoaded(item.id)"
              [scale]="scale | async"
              [spineSnapKey]="
                item.config.transform +
                '|' +
                item.config.width +
                '|' +
                item.config.height
              "
              [faceMatch]="tabloFaceToPerson$ | async"
              (editCrop)="editCrop.next($event)"
              [showSpine]="showSpine"
              (editCustomIndex)="
                editCustomIndex.emit({ index: $event, group: item })
              "
            ></lib-tablo-members-group>
          </div>
        </div>
      }

      @case ('qr') {
        <div
          [ngClass]="{
            locked: item.config.locked,
          }"
          class="element"
        >
          @if (
            !item.editMode &&
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              (drag)="onDrag($event, item)"
              (dragStart)="onDragStart($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              [draggable]="!item.editMode"
              [resizable]="false"
              [scalable]="false"
              [edge]="false"
              [origin]="false"
              [pinchable]="false"
              [target]="children"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="
                content | tabloOtherElementsForSnap: children
              "
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [snapDistFormat]="snapDistFormat"
              [bounds]="content | tabloBoundArea: (scale | async)"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }
          <div
            class="elementContainer"
            [id]="item.id"
            #children
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              transform: item.config.transform,
              'z-index': item.config.index,
              opacity: item.config.hidden ? 0 : 1,
            }"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>

            <svg
              width="94"
              height="94"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <desc>Zint Generated Symbol</desc>
              <g id="barcode" fill="#000000">
                <rect x="0" y="0" width="94" height="94" fill="#FFFFFF" />
                <path
                  d="M12 12h6v12h-6ZM24 12h6v6h-6ZM36 12h6v6h-6ZM48 12h6v6h-6ZM60 12h6v6h-6ZM72 12h6v6h-6ZM84 12h6v6h-6ZM24 18h12v6h-12ZM42 18h12v6h-12ZM66 18h30v6h-30ZM12 24h12v6h-12ZM42 24h6v6h-6ZM54 24h6v6h-6ZM72 24h6v6h-6ZM12 30h6v6h-6ZM24 30h6v6h-6ZM36 30h6v6h-6ZM48 30h30v6h-30ZM90 30h6v6h-6ZM12 36h12v6h-12ZM30 36h18v6h-18ZM60 36h6v6h-6ZM12 42h24v6h-24ZM60 42h12v6h-12ZM78 42h6v6h-6ZM90 42h6v6h-6ZM12 48h6v18h-6ZM54 48h18v6h-18ZM78 48h12v6h-12ZM36 54h6v6h-6ZM48 54h12v12h-12ZM84 54h12v6h-12ZM24 60h6v6h-6ZM66 60h12v6h-12ZM84 60h6v6h-6ZM12 66h18v6h-18ZM42 66h6v6h-6ZM60 66h6v6h-6ZM72 66h6v6h-6ZM84 66h12v6h-12ZM12 72h24v6h-24ZM66 72h12v6h-12ZM84 72h6v6h-6ZM12 78h6v12h-6ZM24 78h6v6h-6ZM36 78h6v6h-6ZM48 78h6v6h-6ZM60 78h6v6h-6ZM72 78h12v6h-12ZM90 78h6v6h-6ZM30 84h6v6h-6ZM54 84h6v6h-6ZM66 84h6v6h-6ZM78 84h6v6h-6ZM12 90h84v6h-84Z"
                />
              </g>
            </svg>
          </div>
        </div>
      }
      @case ('text') {
        <div
          class="element text"
          (dblclick)="openEditMode.emit(item)"
          [ngClass]="{
            hovered: item.isOnHover && !item.editMode,
            locked: item.config.locked,
          }"
        >
          @if (
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              [draggable]="true"
              [resizable]="true"
              [scalable]="true"
              (drag)="onDrag($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              (resizeEnd)="onResizeEnd($event, item)"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              [rotatable]="true"
              [target]="children"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="
                content | tabloOtherElementsForSnap: children
              "
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [bounds]="content | tabloBoundArea: (scale | async)"
              [snapDistFormat]="snapDistFormat"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }

          <div
            class="elementContainer"
            [id]="item.id"
            #children
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              'left.px': item.config.x,
              'top.px': item.config.y,
              transform: item.config.transform,
              'z-index': item.config.index,
              opacity: item.config.hidden ? 0 : 1,
            }"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>

            <div>
              <h1
                libFitIntoContainer
                [scale]="scale | async"
                [resized]="
                  elementResized | filterEventsForElement: item.id | async
                "
                (allCompleted)="textLoaded()"
                [elementId]="item.id"
                [verticalAlign]="item.config.config.verticalAlign"
                [maxFontSize]="item.config.config.fontSize"
                [ngStyle]="{
                  'text-align': item.config.config.align,
                  'font-family': $safeNavigationMigration(
                    item.config.config?.font?.fontId
                  ),
                  color: item.config.config.color,
                  'letter-spacing':
                    item.config.config.fontLatterSpacing === 0
                      ? 'normal'
                      : item.config.config.fontLatterSpacing + 'em',
                  'text-transform': item.config.config.uppercase
                    ? 'uppercase'
                    : 'none',
                }"
              >
                {{ item.config | resolveTabloText }}
              </h1>
            </div>
          </div>
        </div>
      }
      @case ('statictext') {
        <div
          class="element text"
          (dblclick)="openEditMode.emit(item)"
          [ngClass]="{
            hovered: item.isOnHover && !item.editMode,

            locked: item.config.locked,
          }"
        >
          @if (
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              [draggable]="true"
              [resizable]="true"
              [scalable]="true"
              (dragStart)="onDragStart($event, item)"
              (drag)="onDrag($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              [rotatable]="true"
              (resizeEnd)="onResizeEnd($event, item)"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              [rotatable]="true"
              [target]="children"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="
                content | tabloOtherElementsForSnap: children
              "
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [bounds]="content | tabloBoundArea: (scale | async)"
              [snapDistFormat]="snapDistFormat"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }

          <div
            class="elementContainer"
            [id]="item.id"
            #children
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              top: 0,
              left: 0,
              transform: item.config.transform,
              'z-index': item.config.index,
              opacity: item.config.hidden ? 0 : 1,
            }"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>

            <div
              [ngStyle]="
                item.config.config
                  | staticTextHorizontalAligment
                    : (item.config.index !== undefined
                        ? item.config.index
                        : itemIndex)
              "
              class="staticTextContainer"
              [libDetectOverflow]="!printMode"
              (overFlowDetected)="
                children.classList.toggle('hasOverFlowAlert', $event);
                overflowError.emit({
                  page: currentPage$.value,
                  id: item.id,
                  hasError: $event,
                })
              "
            >
              <div
                style="width: 100%"
                [innerHTML]="
                  item.config.config.text | parseStaticText: item.config.config
                "
              ></div>
            </div>
            <div class="overFlowAlert">Takst nie mieści sie w tym obszarze</div>
          </div>
        </div>
      }
      @case ('graphic') {
        <div
          class="element text"
          (dblclick)="openEditMode.emit(item)"
          [ngClass]="{
            hovered: item.isOnHover && !item.editMode,
            locked: item.config.locked,
          }"
        >
          @if (
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              [draggable]="true"
              [resizable]="true"
              [scalable]="true"
              (dragStart)="onDragStart($event, item)"
              (drag)="onDrag($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              [rotatable]="true"
              (resizeEnd)="onResizeEnd($event, item)"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              [target]="children"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="
                content | tabloOtherElementsForSnap: children
              "
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [bounds]="content | tabloBoundArea: (scale | async) : true"
              [snapDistFormat]="snapDistFormat"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }
          <div
            class="elementContainer customGraphic"
            #children
            [id]="item.id"
            [ngStyle]="item | customGraphicsParentCss"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>
            @if (item.config.fileName) {
              <img
                draggable="false"
                [ngStyle]="
                  item
                    | customGraphicStyles
                      : ({ photoId: item.config.fileName }
                          | getImageUrl
                            : projectId + '-assets'
                            : 'photographer'
                            : 'DesignerAsset'
                            : projectId
                            : 2000
                          | async)
                "
                [src]="
                  !item.config.config?.hasColorOverlay
                    ? ({ photoId: item.config.fileName }
                      | getImageUrl
                        : projectId + '-assets'
                        : 'photographer'
                        : 'DesignerAsset'
                        : projectId
                        : 2000
                      | async)
                    : ''
                "
              />
            } @else {
              <ng-template [ngTemplateOutlet]="logoPlaceholder"></ng-template>
            }
            <ng-template #logoPlaceholder>
              <img
                draggable="false"
                src="/assets/designer/schoolLogoPlaceholder.svg"
              />
            </ng-template>
          </div>
        </div>
      }
      @case ('photoOfSchool') {
        <div
          class="element text"
          (dblclick)="openEditMode.emit(item)"
          [ngClass]="{
            hovered: item.isOnHover && !item.editMode,
            locked: item.config.locked,
          }"
        >
          @if (
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              [draggable]="true"
              [resizable]="true"
              [scalable]="true"
              (dragStart)="onDragStart($event, item)"
              (drag)="onDrag($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              [rotatable]="true"
              (resizeEnd)="onResizeEnd($event, item)"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              [target]="children"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="
                content | tabloOtherElementsForSnap: children
              "
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [bounds]="content | tabloBoundArea: (scale | async) : true"
              [snapDistFormat]="snapDistFormat"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }
          <div
            class="elementContainer staticPhoto"
            [ngClass]="{
              isCircle: $safeNavigationMigration(
                item.config.config?.photoAsCircle
              ),
            }"
            [attr.id]="item.id"
            #children
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              top: 0,
              left: 0,
              transform: item.config.transform,
            }"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>

            <div
              class="staticImageContainer"
              [ngStyle]="{
                overflow: 'hidden',
                'border-width': item.config.config.childPhotoFrameWidth + 'px',
                'border-color': item.config.config.childPhotoFrameColor,
                'background-color': item.config.config.childPhotoFrameColor,
                'border-style': 'solid',
                'border-radius': item.config.config?.photoAsCircle
                  ? '50%'
                  : item.config.config.childRadius + 'px',
                'box-shadow': item.config.config.childPhotoShadow,
              }"
            >
              @if (item.config.config.fileName) {
                <lib-cover
                  [scale]="item.config.config.scale * (scale | async)"
                  [imageSize]="{
                    w: item.config.config.width,
                    h: item.config.config.height,
                  }"
                  [point]="{
                    x: item.config.config.x,
                    y: item.config.config.y,
                  }"
                  style="transform:scale({{ item.config.config.scale }})"
                  (loaded)="imageLoaded(item.id)"
                  [url]="
                    item.config.config.fileName
                      | publicImageUrl: 3000 : 3000
                      | async
                  "
                >
                </lib-cover>
              } @else {
                <ng-template [ngTemplateOutlet]="logoPlaceholder"></ng-template>
              }
              <ng-template #logoPlaceholder>
                <img
                  draggable="false"
                  src="/assets/designer/schoolPhotoPlaceholder.svg"
                />
              </ng-template>
              <div
                class="staticImageContainerBorderOverlay"
                [ngStyle]="{
                  overflow: 'hidden',
                  'border-width':
                    item.config.config.childPhotoFrameWidth + 'px',
                  'border-color': item.config.config.childPhotoFrameColor,

                  'border-style': 'solid',
                  'border-radius': item.config.config?.photoAsCircle
                    ? '50%'
                    : item.config.config.childRadius + 'px',
                }"
              ></div>
            </div>
          </div>
        </div>
      }
      @case ('staticChildPhoto') {
        <div
          class="element text"
          (dblclick)="openEditMode.emit(item)"
          [ngClass]="{
            hovered: item.isOnHover && !item.editMode,
            locked: item.config.locked,
          }"
        >
          @if (
            item.id === (hoverOver | async) &&
            !disabled &&
            !(scaleUpdated$ | async)
          ) {
            <lib-zoneless-moveable
              [draggable]="true"
              [resizable]="true"
              [scalable]="true"
              (dragStart)="onDragStart($event, item)"
              (drag)="onDrag($event, item)"
              (dragEnd)="onDragEnd($event, item)"
              (resize)="onResize($event, item)"
              (rotate)="onRotate($event, item)"
              (rotateEnd)="onRotateEnd($event, item)"
              (rotateStart)="onRotateStart($event, item)"
              [rotatable]="true"
              (resizeEnd)="onResizeEnd($event, item)"
              [edge]="false"
              [keepRatio]="false"
              [origin]="false"
              [pinchable]="false"
              [target]="children"
              [throttleDrag]="0"
              [throttleResize]="0"
              [throttleRotate]="0"
              [throttleScale]="0"
              [snappable]="true"
              [elementGuidelines]="
                content | tabloOtherElementsForSnap: children
              "
              [verticalGuidelines]="
                content | verticalGuidesForTablo: (scale | async)
              "
              [horizontalGuidelines]="
                content | horizontalGuidesForTablo: (scale | async)
              "
              [bounds]="content | tabloBoundArea: (scale | async) : true"
              [snapDistFormat]="snapDistFormat"
              [snapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
              [elementSnapDirections]="{
                left: true,
                right: true,
                top: true,
                bottom: true,
                center: true,
                middle: true,
              }"
            ></lib-zoneless-moveable>
          }
          <div
            class="elementContainer staticPhoto"
            #children
            [ngClass]="{
              isCircle: $safeNavigationMigration(
                item.config.config?.photoAsCircle
              ),
            }"
            [id]="item.id"
            [ngStyle]="{
              'width.px': item.config.width,
              'height.px': item.config.height,
              top: 0,
              left: 0,
              transform: item.config.transform,
              'z-index': item.config.index,
              opacity: item.config.hidden ? 0 : 1,
            }"
          >
            <div class="focusStealer" [attr.data-id]="item.id"></div>

            <div
              class="staticImageContainer"
              [ngStyle]="{
                overflow: 'hidden',
                'border-width': item.config.config.childPhotoFrameWidth + 'px',
                'border-color': item.config.config.childPhotoFrameColor,
                'background-color': item.config.config.childPhotoFrameColor,
                'border-style': 'solid',
                'border-radius': item.config.config?.photoAsCircle
                  ? '50%'
                  : item.config.config.childRadius + 'px',
                'box-shadow': item.config.config.childPhotoShadow,
              }"
            >
              @if (item.config.config.photoId) {
                <lib-cover
                  [scale]="item.config.config.scale * (scale | async)"
                  [title]="item.config.config | json"
                  [imageSize]="{
                    w: item.config.config.width,
                    h: item.config.config.height,
                  }"
                  [point]="{
                    x: item.config.config.x,
                    y: item.config.config.y,
                  }"
                  style="transform:scale({{ item.config.config.scale }})"
                  (loaded)="imageLoaded(item.id)"
                  [url]="
                    {
                      photoId: $safeNavigationMigration(
                        $safeNavigationMigration(item.config.config?.photoId)
                      ),
                    }
                      | getImageUrl
                        : $safeNavigationMigration(
                            $safeNavigationMigration(
                              item.config.config?.photoGroupId
                            )
                          )
                        : 'photographerDesigner'
                        : context
                        : projectId
                        : 3000
                      | async
                  "
                >
                </lib-cover>
              } @else {
                <ng-template [ngTemplateOutlet]="logoPlaceholder"></ng-template>
              }

              <ng-template #logoPlaceholder>
                @if (item.config.config.fileName) {
                  <img
                    draggable="false"
                    [src]="
                      item.config.config.fileName
                        | publicImageUrl: 3000 : 3000
                        | async
                    "
                  />
                } @else {
                  <ng-template
                    [ngTemplateOutlet]="logoPlaceholder2"
                  ></ng-template>
                }
                <ng-template #logoPlaceholder2
                  ><img
                    draggable="false"
                    src="/assets/designer/schoolChildPhotoPlaceholder.svg"
                /></ng-template>
              </ng-template>

              <div
                class="staticImageContainerBorderOverlay"
                [ngStyle]="{
                  overflow: 'hidden',
                  'border-width':
                    item.config.config.childPhotoFrameWidth + 'px',
                  'border-color': item.config.config.childPhotoFrameColor,

                  'border-style': 'solid',
                  'border-radius': item.config.config?.photoAsCircle
                    ? '50%'
                    : item.config.config.childRadius + 'px',
                }"
              ></div>
            </div>
            @if (
              item.config.config.childPhotoOverlayFileName;
              as overlayImage
            ) {
              <img
                draggable="false"
                class="photoOverlay"
                [ngStyle]="{
                  transform:
                    'scale(' + item.config.config.childPhotoOverlayScale + ')',
                }"
                [src]="
                  {
                    photoId: overlayImage,
                  }
                    | getImageUrl
                      : projectId + '-assets'
                      : 'photographer'
                      : 'DesignerAsset'
                      : projectId
                      : 3000
                    | async
                "
              />
            }
          </div>
        </div>
      }
    }
  }
  @if ((isShiftDown$ | async) && (imageUrl$ | async)) {
    <div
      class="backgroundEditOverlay"
      (pointerdown)="startBackgroundEdit($event)"
      (pointermove)="moveBackgroundEdit($event)"
      (pointerup)="finishBackgroundEdit($event)"
      (pointercancel)="finishBackgroundEdit($event)"
    ></div>
  }
  <div class="printOverlay"></div>
</div>

<!--<textarea>{{ structure$ | async | json }}</textarea>-->
